import styled from 'styled-components';

export const StyledText = styled.p`
	margin-bottom: 10px;
`;

export const HelpSection = styled.div<{ isSmallScreen: boolean }>`
	margin: ${({ isSmallScreen }) => (isSmallScreen ? '20px 0' : '35px 0')};
`;

export const HelpLinkText = styled.a`
	display: block;
	font-style: italic;
	text-decoration: underline;
`;

export const TermSection = styled.ul<{ isSmallScreen: boolean }>`
	background-color: ${({ theme }) => theme.colors.light};
	margin-bottom: ${({ isSmallScreen }) => (isSmallScreen ? '15px' : '50px')};
	padding: 10px 5px;
`;

export const TermsTitle = styled.p`
	display: flex;
	margin-bottom: 5px;
	font-weight: 600;
	align-items: center;
`;

export const TermItemText = styled.li`
	padding-left: 10px;
	margin-bottom: 5px;
	font-weight: 600;
`;

export const TermLink = styled.a`
	display: block;
	margin-bottom: 5px;
	font-weight: 600;
	text-decoration: underline;
`;

export const ButtonLink = styled.a`
	border: 1px solid ${({ theme }) => theme.colors.light};
	margin-bottom: 15px;
	padding: 8px 0;
	text-align: center;
`;
